module.exports = __webpack_public_path__ + "img/548.d85db3a5.jpg";